export default {"src":"/_next/static/media/socall.0a6e9c78.svg","height":54,"width":125,"blurWidth":0,"blurHeight":0};